<div class="confirm-modal ig-modal create-trip-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>

    <div class="title">CREATE, PLAN AND SHARE MULTIPLE TRIPS</div>

    <div class="tip">
        Use our trip planner to create, plan your stops and share multiple trips. Start by naming your itinerary, add or
        remove items, and share with friends. For example, add "Day 1 - Family Vacation" as a trip, and add "Day 2 -
        Family Vacation" as a second trip to organize your activities.
        <br>
        <br>
        Start by naming your trip:
    </div>

    <form ngForm="tripFormGroup">
        <ig-row>
            <ig-col [xs]="12" [md]="9">
                <ig-mat-field
                        [label]="newTripLabel"
                        [(ngModel)]="newTripTitle"
                        [isRequired]="true"
                        [formControl]="tripFormGroup.get('tripTitle')"
                ></ig-mat-field>
            </ig-col>
            <ig-col [xs]="12" [md]="3" btn>
                <ig-button size="md" class="ig-blue-btn" (trigger)="createTrip($event)">create trip</ig-button>
            </ig-col>
        </ig-row>

    </form>

    <div class="flex bottom-wrap">
        <div text>
            You can view all trips you have created by clicking the icon
        </div>
        <div icon>
            <mat-icon>work</mat-icon>
            <!--<div>My Trips</div>-->
        </div>
    </div>

</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/create.trip.modal/create.trip.modal.component.html